import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from "i18next";
import enUsTrans from "../../public/locales/en-us.json";
import zhCNTrans from "../../public/locales/zh-cn.json";
import krTrans from "../../public/locales/kr-kr.json";
import jpTrans from "../../public/locales/jp-jp.json";
import frFr from "../../public/locales/fr-fr.json";

import {
  initReactI18next
} from 'react-i18next';

// 服务器端使用默认语言
const defaultLanguage = 'en';

i18n.use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enUsTrans,
      },
      cn: {
        translation: zhCNTrans,
      },
      kr: {
        translation: krTrans,
      },
      jp: {
        translation: jpTrans,
      },
      fr: {
        translation: frFr,
      }
    },
    lng: defaultLanguage, // 服务器端渲染时使用默认语言
    fallbackLng: defaultLanguage,
    detection: {
      order: ['navigator', 'localStorage'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
